export const MultiOptionsSwitchTheme = ({theme: {fonts, colors, icons}}) => {
  return {
    label: {
      ...fonts.ACTION,
      color: colors.NEUTRAL_HIGH,
      flex: 1,
    },
  };
};
